import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { CLINICS } from '../../constant';

interface Payload {
  clinicId: string;
  /**
   * Partial by design — send only the switch that moved. The server merges it
   * onto the clinic's current flags, so an omitted key keeps its value instead
   * of being reset to a default.
   */
  features: {
    dicomViewer?: boolean;
    measurement?: boolean;
    autoDistribution?: boolean;
    senderCopy?: boolean;
  };
  /** Auto distribution settings; only sent when they change. */
  autoDistribution?: { recipientId?: string; format?: 'pdf' | 'txt' | 'rtf' };
}

/** Toggle a feature for one clinic. Super admin only (enforced server-side). */
export const updateFeatureControlApi = createAsyncThunk(
  'featureControl/update',
  async (payload: Payload, { rejectWithValue }) => {
    try {
      const requestOptions = {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
        body: JSON.stringify(payload),
      };

      const res = await fetch(CLINICS.FEATURE_CONTROL_URL, requestOptions);

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        return rejectWithValue(errorData.msg || 'Failed to update feature flags');
      }

      return await res.json();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
